/*
 * von rxjs übernommen nachdem es dort entfernt wurde
 * */
export const isArray = (() =>
  Array.isArray || (<T>(x: any): x is T[] => x && typeof x.length === 'number'))();
